import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import NavbarPC from "../../../components/navbar-pc/navbar-pc";
import NavbarMobile, { AddLighdGlass } from "../../../components/navbar-mobile/navbar-mobile";
import ChatGlobal from "../../Chat/chat-global";
import { shouldHideMenus } from "../../../utils/platform";

const MainMenu = () => {
    const hideMenus = shouldHideMenus();

    return (
        <div>
            {!hideMenus && (
                <>
                    <NavbarMobile />
                    <AddLighdGlass />
                    <NavbarPC />
                </>
            )}

            <Outlet />
            {!hideMenus && <ChatGlobal/>}
        </div>
    );
};

export default MainMenu;
